<template>
  <v-dialog v-model="dialog" max-width="500" @keydown.esc="cancel()">
    <v-card tile>
      <v-card-title class="headline" primary-title>
        {{$t("Logout?")}}
      </v-card-title>
      <v-card-text>{{$t("Do you want to logout?")}}</v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#93D2ED" @click="logoutMS"><v-icon left>login</v-icon>{{$t("Yes")+" (MS Logout)"}}</v-btn>
        <v-btn color="error" @click="logout">{{$t("Yes")}}</v-btn>
        <v-btn color="primary" @click="cancel">{{$t("No")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as Security from '@/core/security'

export default {
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    open () {
      this.dialog = true
    },
    async logout () {
      await Security.logout()
      this.dialog = false
    },
    async logoutMS () {
      await Security.logout(true)
      this.dialog = false
    },
    cancel () {
      this.dialog = false
    }
  }
}
</script>
